import { createContext } from 'react';

/**
 * Estado del drawer de navegación MOBILE (hamburguesa → panel deslizante).
 * Lo consumen AppBar (abrir), MobileSidebarDrawer (render) y RoleTour (abrirlo
 * antes de correr el tour para que las anclas del menú existan en el DOM).
 */
const SidebarDrawerContext = createContext({
  mobileOpen: false,
  openMobileSidebar: () => {},
  closeMobileSidebar: () => {}
});

export default SidebarDrawerContext;
